<template>
  <!-- 标题栏组件 -->
  <div
  
    class="title-bar-container"
    :style="{
      paddingTop: `${datas.paddingTop}px`,
      paddingBottom: `${datas.paddingBottom}px`,
      paddingLeft: `${datas.paddingLeft}px`,
      paddingRight: `${datas.paddingRight}px`,
      backgroundColor: datas.bgColor,
    }"
  >
    <div v-if="!isShow" :class="{ mask: !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <!-- 标题栏核心内容 -->
    <div class="title-bar-content" >
      <!-- 左侧装饰区（竖线 + 图标/图片） -->
      <div class="title-bar-left">
        <!-- 此判断根据后续需要去除 -->
        <div v-if="datas.showLine">
          <!-- 左侧竖线 -->
          <div v-if="datas.iconType === 'line'" class="title-bar-line"></div>
          <div v-else-if="datas.iconType === ''"></div>
          <!-- 左侧图标 -->
          <div v-else class="title-bar-icon">
            <i
              v-if="datas.image.includes('iconfont')"
              :class="datas.image"
              style="font-size: 20px"
            ></i>
            <van-icon
              v-else
              :color="`var(--theme-primary)`"
              :name="datas.image"
              size="20px"
            />
          </div>
        </div>

        <div
          class="titlebar-text"
          :style="{
            color: datas.textColor,
            fontSize: `${datas.textSize}px`,
            fontWeight: datas.fontWeight,
          }"
        >
          {{ datas.text || "标题栏" }}
        </div>
      </div>
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>
<script>
export default {
  name: "titlebar",
  props: {
    datas: Object,
    isShow: Boolean,
  },
  created() {
    console.log(
      "titlebar子组件挂载了--------------------111-1-1-1-1-1--1",
      this.datas,
    );
    // 兼容处理：如果iconColor未传，默认使用lineColor
    // if (!this.datas.iconColor && this.datas.lineColor) {
    //   this.datas.iconColor = this.datas.lineColor;
    // }
  },
};
</script>
<style lang="scss" scoped>
/* 标题栏容器：适配移动端流式布局 */
.title-bar-container {
  width: 100%;
  box-sizing: border-box;
 
}
/* 标题栏内容：横向排列，居中对齐 */
.title-bar-content {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 10px;
}
/* 左侧装饰区：竖线+图标组合 */
.title-bar-left {
  display: flex;
  align-items: center;
}
/* 左侧竖线：垂直装饰条 */
.title-bar-line {
  border-radius: 3px;
  width: 4px;
  height: 18px;
  background-color: var(--theme-primary);
  margin-right: 5px;
}
.title-bar-icon {
  display: flex;
  align-items: center;
  padding-right: 5px;
}
</style>
